import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const NewFeatureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewFeature"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"MemberHeader"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oneTimeMessagesDismissed"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"NewFeature","document":NewFeatureDocument}} as const;
export type NewFeatureQueryVariables = Types.Exact<{
  memberId: Types.Scalars['ID'];
}>;


export type NewFeatureQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id' | 'oneTimeMessagesDismissed'>
  )> }
);




/**
 * __useNewFeatureQuery__
 *
 * To run a query within a React component, call `useNewFeatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewFeatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewFeatureQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useNewFeatureQuery(baseOptions: Apollo.QueryHookOptions<NewFeatureQuery, NewFeatureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewFeatureQuery, NewFeatureQueryVariables>(NewFeatureDocument, options);
      }
export function useNewFeatureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewFeatureQuery, NewFeatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewFeatureQuery, NewFeatureQueryVariables>(NewFeatureDocument, options);
        }
export type NewFeatureQueryHookResult = ReturnType<typeof useNewFeatureQuery>;
export type NewFeatureLazyQueryHookResult = ReturnType<typeof useNewFeatureLazyQuery>;
export type NewFeatureQueryResult = Apollo.QueryResult<NewFeatureQuery, NewFeatureQueryVariables>;